import {
  GET_INVOICE_CONFIG_SUCCESS,
  GET_INVOICE_CONFIG_FAILED,
  RESET_GET_INVOICE_CONFIG,
  LOADING_GET_INVOICE_CONFIG,
  NETWORK_ERROR_GET_INVOICE_CONFIG,
} from "../types/index";
import { invoiceServices } from "../../config/axios";

const resetgetInvoicesCofig = () => {
  return { type: RESET_GET_INVOICE_CONFIG };
};

const getInvoicesCofig = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_GET_INVOICE_CONFIG });
  await invoiceServices
    .post("getInvoiceConfig", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.status) {
        case 200:
          dispatch(getInvoiceConfigsuccess(res.data));
          break;
        default:
          dispatch(getInvoiceConfigFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({
        type: NETWORK_ERROR_GET_INVOICE_CONFIG,
        payload: err,
      });
    });
};
function getInvoiceConfigsuccess(data) {
  return {
    type: GET_INVOICE_CONFIG_SUCCESS,
    payload: data,
  };
}
function getInvoiceConfigFailed(data) {
  return {
    type: GET_INVOICE_CONFIG_FAILED,
    payload: data,
  };
}

export { resetgetInvoicesCofig, getInvoicesCofig };
